import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";


export const generateHosting = async (hostingId, brandName, bizNum, channelId) => {
    const res = await fetchApi.post(API_URL.HOSTING_GENERATE, {
        hostingId, brandName, bizNum, channelId
    })
    return res.data
}
export const getHostingInfo = async (channelId) => {
    const res = await fetchApi.get(`${API_URL.HOSTING_INFO}?channelId=${channelId}`)
    return res.data
}